import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {SessaoService} from './sessao.service';
import {take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PossuiPermissoesService implements CanActivate {

  constructor(
    private router: Router,
    private sessaoService: SessaoService,
  ) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const autenticado = await this.sessaoService.autenticado.pipe(take(1)).toPromise();

    if (autenticado) {
      return true;
    }

    // this.mensageria.addMensagem('Desculpe, você não possui acesso a essa áera.');
    const redirectTo: Array<string> = !!route.data.redirectTo ? typeof route.data.redirectTo === 'string' ?
      route.data.redirectTo.split('/') : route.data.redirectTo : ['acesso', 'login'];
    return await this.router.navigate(redirectTo, {
      queryParams: state.url !== '/' + redirectTo.join('/') ? {to: state.url, ...(route.queryParamMap || {})} : {}
    });
  }
}
